module.exports = __webpack_public_path__ + "static/media/11.730a881a.jpg";